// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__1Nec3","Label":"Input_Label__2QNoq","InputElement":"Input_InputElement__3IQ3x","Invalid":"Input_Invalid__Rmqkc"};